import React, { useEffect } from 'react'
import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'

const PartnersReportPdf = ({
  companySupplierAuditId,
  exportingPdf = false,
  partners = [],
  reportType = 'reportByAllPartners',
  refresh = () => {},
  setExportingPdf,
  shouldCreateVersion,
}) => {
  const snackbar = useSnackbar()

  useEffect(() => {
    const generateReport = async () => {
      try {
        const partnerIds = partners.map((partner) => partner.id)

        await service.dponet.suppliers.partnerExportReport({
          partnerIds,
          companySupplierAuditId,
          reportType,
          shouldCreateVersion,
        })

        snackbar.open({
          message:
            'Seu relatório será gerado e enviado ao seu e-mail. Pode demorar alguns minutos.',
          variant: 'success',
        })
        refresh()
      } catch (error) {
        snackbar.open({
          message: 'Houve um erro durante a criação do relatório.',
          variant: 'error',
        })
      } finally {
        setExportingPdf(false)
      }
    }

    if (exportingPdf) {
      generateReport()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportingPdf])
  return <></>
}

export default PartnersReportPdf
